import script from "./LocLoanConfigurationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocLoanConfigurationModal.vue?vue&type=script&setup=true&lang=ts"

import "./LocLoanConfigurationModal.vue?vue&type=style&index=0&id=2b774a22&lang=css"

const __exports__ = script;

export default __exports__